import type { Device } from '@types';

/** VR headsets that do not already have a paired sensor. */
export function getAvailableVrHeadsets(devices: Device[]): Device[] {
  const pairedVrIds = new Set(
    devices
      .filter(
        d =>
          d.type === 'smartwatch' &&
          d.connected_to != null &&
          d.connected_to !== ''
      )
      .map(d => String(d.connected_to))
  );

  return devices.filter(
    d => d.type === 'vr-headset' && !pairedVrIds.has(String(d.id))
  );
}

/** True if at least one VR headset can accept a new sensor pair. */
export function canPairSensor(devices: Device[]): boolean {
  return getAvailableVrHeadsets(devices).length > 0;
}
